import { useEffect, useRef, useState } from "react";
import "../assets/css/crud.css"; // Asegúrate de que la ruta sea correcta

function Crud({ baseURL }) {
  const [login, setLogin] = useState(false);
  const [collection, setCollection] = useState("posts");
  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState(null); // Nuevo estado para el archivo
  const [editingId, setEditingId] = useState(null);
  const modalRef = useRef(null);

  const apiURL = `${baseURL}${collection}`;

  // Cargar items según colección activa
  useEffect(() => {
    fetch(apiURL)
      .then((res) => res.json())
      .then((data) => {
        setItems(data);
      })
      .catch(console.error);
  }, [collection]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault(); // Necesario en algunos navegadores
      e.returnValue = ""; // Esto activa el diálogo de confirmación
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const changeCollection = (name) => {
    setCollection(name);
  };

  const openModal = (item = {}) => {
    setFormData(item);
    setEditingId(item._id || null);
    setFile(null); // Limpiar archivo al abrir modal
    if (modalRef.current) modalRef.current.style.display = "block";
  };

  const closeModal = () => {
    setFormData({});
    setEditingId(null);
    setFile(null); // Limpiar archivo al cerrar modal
    if (modalRef.current) modalRef.current.style.display = "none";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Tamaño máximo permitido (por ejemplo, 5MB)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

    // Validar tamaño de archivo si hay uno
    if (file && file.size > MAX_FILE_SIZE) {
      alert(
        "La imagen es demasiado grande. El tamaño máximo permitido es 5MB."
      );
      return; // No continúa
    }

    const dataToSend = new FormData();
    dataToSend.append("name", formData.name || "");
    dataToSend.append("description", formData.description || "");
    if (file) dataToSend.append("image", file);

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `${apiURL}/${editingId}` : apiURL;

    const res = await fetch(url, {
      method,
      body: dataToSend,
    });

    const data = await res.json();
    if (!res.ok) return alert(data.error || "Error");
    closeModal();
    fetch(apiURL)
      .then((r) => r.json())
      .then(setItems);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar este elemento?")) return;
    await fetch(`${apiURL}/${id}`, { method: "DELETE" });
    fetch(apiURL)
      .then((r) => r.json())
      .then(setItems);
  };

  if (!login) {
    const validateLogin = (event) => {
      event.preventDefault();
      if (event.target.password.value === "mda-admin") {
        setLogin(true);
      } else {
        alert("Llave incorrecta, intente de nuevo");
      }
    };

    return (
      <section className="login-container">
        <h1>Ingrese la llave de acceso</h1>
        <form onSubmit={validateLogin}>
          <input
            type="password"
            name="password"
            required
            autoComplete="current-password"
          />
          <button>Continuar</button>
        </form>
      </section>
    );
  }

  return (
    <div div className="crud-view">
      <div className="container">
        <h1>Panel de Administración MDA</h1>

        <div className="tabs">
          <button
            className={`tab-button ${collection === "posts" ? "active" : ""}`}
            onClick={() => changeCollection("posts")}
          >
            Mercado
          </button>
          <button
            className={`tab-button ${collection === "gallery" ? "active" : ""}`}
            onClick={() => changeCollection("gallery")}
          >
            Galería
          </button>
        </div>

        <div className="collection-header">
          <h2>{collection.charAt(0).toUpperCase() + collection.slice(1)}</h2>
          <button className="btn" onClick={() => openModal()}>
            Crear Nuevo
          </button>
        </div>

        {items.length === 0 && <p>No hay elementos en esta sección.</p>}

        {/* TABLA POSTS */}
        {collection === "posts" && (
          <table className="crud-table">
            <thead>
              <th>Titulo</th>
              <th>Descripción</th>
              <th>Portada</th>
              <th>Fecha</th>
              <th>Opciones</th>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.description}</td>
                  <td>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{ width: "50px", height: "50px" }}
                      draggable={false}
                    />
                  </td>
                  <td>
                    {item.createdAt ? item.createdAt.split("T")[0] : null}
                  </td>
                  <td>
                    <button onClick={() => openModal(item)}>✏️</button>
                    <button onClick={() => handleDelete(item._id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* GALERÍA */}
        {collection === "gallery" && (
          <table className="crud-table">
            <thead>
              <th>Imagen</th>
              <th>Fecha</th>
              <th>Opciones</th>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{ width: "50px", height: "50px" }}
                      draggable={false}
                    />
                  </td>
                  <td>
                    {item.createdAt ? item.createdAt.split("T")[0] : null}
                  </td>
                  <td>
                    <button onClick={() => openModal(item)}>✏️</button>
                    <button onClick={() => handleDelete(item._id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* MODAL */}
      <div className="modal" ref={modalRef} style={{ display: "none" }}>
        <div className="modal-content">
          <span className="close-btn" onClick={closeModal}>
            &times;
          </span>
          <h2>{editingId ? "Editar" : "Nuevo"}</h2>

          {collection === "posts" && (
            <form id="modalForm" onSubmit={handleSubmit}>
              <label>
                Título:
                <input
                  type="text"
                  maxLength={30}
                  placeholder="Limite: 40 caracteres"
                  value={formData.name || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </label>
              <label>
                Descripción:
                <input
                  type="text"
                  maxLength={100}
                  placeholder="Limite: 120 caracteres"
                  value={formData.description || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  required
                />
              </label>
              <label>
                Portada:
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                />
              </label>
              <br />
              <button type="submit" className="btn">
                Guardar
              </button>
            </form>
          )}

          {collection === "gallery" && (
            <form id="modalForm" onSubmit={handleSubmit}>
              <label>
                Imagen:
                <input
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/webp"
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                />
              </label>
              <br />
              <button type="submit" className="btn">
                Guardar
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Crud;
